




import Vue from 'vue'

import { PriceSettings } from '@/types/price-settings'

import cell from '@/components/root-components/product-price-setting/_common/cell.vue'

export default Vue.extend({
    name: 'min-volume-cell',
    components: {
        cell
    },
    props: {
        data: {} as () => PriceSettings,
        typeCode: String
    },
    methods: {
        updateFromCell(data: number) {
            this.data.MinVolume = data;
            
            this.$store.dispatch('fill', { typeCode: this.typeCode, row: this.data });
        }
    }
    
})
